function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M272 240h240V16c0-8.832-7.168-16-16-16H272v240z",
    style: {},
    fill: "#4caf50",
    "data-original": "#4caf50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 240V0H16C7.168 0 0 7.168 0 16v224h240z",
    style: {},
    fill: "#f44336",
    "data-original": "#f44336",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 272H0v224c0 8.832 7.168 16 16 16h224V272z",
    style: {},
    fill: "#2196f3",
    "data-original": "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 272v240h224c8.832 0 16-7.168 16-16V272H272z",
    style: {},
    fill: "#ffc107",
    "data-original": "#ffc107",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoft-icon.06fc6d373e2c82c612fbff5ec61f8172.svg";
export { ForwardRef as ReactComponent };